<template>
  <section>
    <h1 class="section-head">ผลิตภัณฑ์</h1>
    <app-product-list></app-product-list>
  </section>
</template>

<script>
  import Request from '@/libraries/request'
  import Product_list from '@/components/Product_list'

  export default {
    name: 'Product',
    components: {
      'app-product-list': Product_list
    },
    data() {
      return {
        
      }
    }
  }

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/Product/index.vue